import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IBannerDto, IFilterPaginationDto } from '../models';

@Injectable()
export class BannerService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getBannerList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IBannerDto[]> {
    return this.post(`admin/banner/list/${id}`, model);
  }

  public changeBannerStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/banner/${id}`, null);
  }

  public saveBanner(model: IBannerDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/banner`, model);
  }

  public deleteBanner(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/banner/${id}`);
  }
}
